import React from 'react'
import { useObserver } from 'mobx-react-lite'
import Typography from '@components/std-components/Typography'
import cn from 'classnames'
import * as css from './ForecastTopBarOtbTotals.css'
import { forecastGlobalTopBarStore } from '@modules/wholesale/buyingSessionGroupProductWrapper/stores/ForecastGlobalTopBar/ForecastGlobalTopBarUIStore'
import { config } from '@config'
import formatCurrencyValueByLocale from '@utils/format-currency-value-by-locale'
import formatNumberByLocale from '@utils/format-number-by-locale'
import { Collapse, Paper } from '@material-ui/core'
import ExpandMore from '@material-ui/icons/ExpandMore'
import ChevronRight from '@material-ui/icons/ChevronRight'
import Seperator from '@components/std-components/Seperator'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { DefaultConfig } from '@constants'

export const ForecastTopBarOtbTotals: React.FC<any> = () => {
  return useObserver(function useHook() {
    const { t } = useTranslation()
    const [isExpanded, setIsExpanded] = React.useState(true)
    const { totalForecastValue, totalForecastQuantity, totalOTBValue, totalOTBQuantity } =
      forecastGlobalTopBarStore.forecastKPIsForTopBar

    const otbValue = totalOTBValue || 0
    const otbQty = totalOTBQuantity || 0

    const actualValue = totalForecastValue || 0
    const actualQty = totalForecastQuantity || 0
    const currency = config.globalCurrency || DefaultConfig.GLOBAL_CURRENCY
    const actualValuePct = otbValue ? (actualValue / otbValue) * 100 : 0
    const actualQtyPct = otbQty ? (actualQty / otbQty) * 100 : 0

    return (
      <Paper className={css.paper} elevation={10}>
        <div className={css.moreButtonWrapper}>
          {isExpanded ? (
            <ChevronRight
              onClick={() => {
                setIsExpanded(prev => !prev)
              }}
            />
          ) : (
            <ExpandMore
              onClick={() => {
                setIsExpanded(prev => !prev)
              }}
            />
          )}
        </div>
        {isExpanded && (
          <div className={css.collapseWrapper}>
            <Collapse in={isExpanded}>
              <div className={css.totalsWrapper}>
                <div className={classNames(css.qtyWrapper, css['inline-value'])}>
                  {/* OTB Value  */}
                  <Typography variant='body2Custom' classes={css.topBarLabel}>
                    {t('order.orderTopbarOTBTotals.otbValue', 'OTB VALUE')}
                  </Typography>
                  <Typography classes={css.valueContainer} variant='subHeading2Custom'>
                    {formatCurrencyValueByLocale(currency, otbValue)}
                  </Typography>
                </div>
                <div className={classNames(css.qtyWrapper, css['inline-value'])}>
                  {/* Actual Value (%) */}
                  <Typography variant='body2Custom' classes={css.topBarLabel}>
                    {t('order.orderTopbarOTBTotals.totalValue', ' TOTAL VALUE (%)')}
                  </Typography>
                  <Typography
                    classes={cn(css.valueContainer, {
                      [css.green]: otbValue < Number(actualValue),
                      [css.red]: otbValue > Number(actualValue)
                    })}
                    variant='subHeading2Custom'
                  >
                    {`${formatCurrencyValueByLocale(
                      currency,
                      actualValue
                    )} (${formatNumberByLocale(actualValuePct, 2)}%)`}
                  </Typography>
                </div>
                <Seperator
                  orientation='vertical'
                  seperatorStyle='solid'
                  seperatorColor='rgba(192,192,192,1)'
                  size='20px'
                  seperatorThickness='1px'
                  margin='4px 16px'
                />
                <div className={classNames(css.qtyWrapper, css['inline-value'])}>
                  {/* OTB QTY */}
                  <Typography variant='body2Custom' classes={css.topBarLabel}>
                    {t('order.orderTopbarOTBTotals.otbQty', 'OTB QTY')}
                  </Typography>
                  <Typography classes={css.valueContainer} variant='subHeading2Custom'>
                    {formatNumberByLocale(otbQty)}
                  </Typography>
                </div>
                <div className={classNames(css.qtyWrapper, css['inline-value'])}>
                  <Typography variant='body2Custom' classes={css.topBarLabel}>
                    {t('order.orderTopbarOTBTotals.totalQty', 'TOTAL QUANTITY (%)')}
                  </Typography>
                  <Typography
                    classes={cn(css.valueContainer, {
                      [css.green]: otbQty < actualQty,
                      [css.red]: otbQty > actualQty
                    })}
                    variant='subHeading2Custom'
                  >
                    {`${formatNumberByLocale(actualQty)} (${formatNumberByLocale(
                      actualQtyPct,
                      2
                    )}%)`}
                  </Typography>
                </div>
              </div>
            </Collapse>
          </div>
        )}
      </Paper>
    )
  })
}
